import { useEffect } from 'react';
import { Feed } from './Feed';
import { Compose } from './Compose';
import { useXClone } from '@/state/xclone';

export function XClone() {
  const markAllRead = useXClone((s) => s.markAllRead);
  const followers = useXClone((s) => s.followers);

  useEffect(() => {
    // mark posts read when surface opens
    markAllRead();
  }, [markAllRead]);

  return (
    <div className="flex h-full flex-col bg-[var(--bg-deep)]">
      <header className="flex items-center justify-between border-b border-[var(--border-subtle)] bg-[var(--bg-surface)] px-4 py-3">
        <svg width="32" height="32" viewBox="0 0 32 32" aria-label="Y" role="img" className="shrink-0">
          {/* X-style Y: thick stark strokes, slight italic lean */}
          <path
            d="M5 5 L16 18 L27 5 L23 5 L16 13 L9 5 Z M14 18 L18 18 L18 28 L14 28 Z"
            fill="var(--text-primary)"
          />
        </svg>
        <span className="text-mono-xs text-[var(--text-muted)] tabular-nums">
          {followers.toLocaleString()} followers
        </span>
      </header>
      <Compose />
      <Feed />
    </div>
  );
}
